import { render, staticRenderFns } from "./NavigationMenuItem.vue?vue&type=template&id=31b47c64&scoped=true&"
import script from "./NavigationMenuItem.vue?vue&type=script&lang=ts&"
export * from "./NavigationMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationMenuItem.vue?vue&type=style&index=0&id=31b47c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b47c64",
  null
  
)

export default component.exports